export const filterEmployeeData = (employeeData, permissions) => {
  if (!employeeData || !permissions) {
    return [];
  }

  const filteredData = [];

  employeeData?.forEach((item) => {
    const matchedPermission = permissions?.find(
      (permission) => permission?.label === item?.text && permission?.isView
    );

    if (matchedPermission && matchedPermission.isView) {
      const filteredItem = {
        ...item,
      };
      filteredData.push(filteredItem);
    } else if (!item?.text && !item?.subOptions) {
      filteredData.push(item);
    } else if (!item?.text && item?.subOptions) {
      const filteredItem = {
        ...item,
        subOptions: filterEmployeeData(item.subOptions, permissions),
      };
      filteredData.push(filteredItem);
    }
  });

  return filteredData;
};
